<template>
  <div class="metadata">
    <div class="metadata__close" @click="close()">
      <svgicon
        class="icon-close"
        icon="icon-close"
        width="13"
        height="13"
      ></svgicon>
    </div>
    <div class="metadata__left">
      <svgicon
        class="icon-metadata"
        icon="icon-metadata"
        width="18"
        height="15"
      ></svgicon>
      <div class="label" v-html="content.intro"></div>
      <div class="title" v-html="content.title"></div>
      <div class="text" v-html="content.dida"></div>
      <div class="label marginTop80" v-html="content.operaLabel"></div>
      <div class="text" v-html="content.operaText"></div>
    </div>
    <div class="metadata__right">
      <div class="label" v-html="content.artistLabel"></div>
      <div class="text" v-html="content.artist"></div>
      <div class="label marginTop80" v-html="content.curaLabel"></div>
      <div class="text" v-html="content.cura"></div>
      <div class="label marginTop80" v-html="content.licenseLabel"></div>
      <div class="text" v-html="content.license"></div>
    </div>
  </div>
</template>
<script>
import "../../compiled-icons/icon-close";
import "@/compiled-icons/icon-metadata";

export default {
  computed: {
    content() {
      return this.$ml.get("audiolibro");
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.metadata {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-h;
  background-color: $black;
  height: 100vh;
  overflow: auto;

  padding-top: 130px;
  .mobile &,
  .tablet & {
    padding-left: 20px;
    padding-right: 20px;
  }

  &__close {
    width: 35px;
    height: 35px;
    background-color: white;
    cursor: pointer;
    position: absolute;
    top: 50px;
    right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    .icon-close {
      fill: black;
    }
    .desktop & {
      top: 35px;
      left: 40px;
      right: unset;
      border-radius: 0;
    }
  }
  .desktop & {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 0;
  }
  &__left {
    .desktop & {
      padding: 0 60px 0 90px;
      height: 100%;
      width: calc(50% - 120px);
      margin-left: 120px;
      border-right: 1px solid $white-30;
      border-left: 1px solid $white-30;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  &__right {
    .desktop & {
      padding: 0 90px 0 60px;
      width: calc(50% - 120px);
      height: 100%;
      margin-right: 120px;
      border-right: 1px solid $white-30;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .icon-metadata {
    fill: white;
    .mobile & {
      //margin-bottom: 40px;
       margin-left: 25px;
    }
    .tablet & {
     // margin-bottom: 30px;
      margin-left: 25px;
    }
    .desktop & {
      margin-bottom: 24px;
      
    }
  }
  .label {
    color: $white;
    @include overlayM;
    text-transform: uppercase;
    .mobile & {
      padding: 60px 16px 10px;
    }
    .tablet & {
      padding: 50px 105px 10px 20px;
    }
    .desktop & {
      &.marginTop80 {
        margin-top: 80px;
      }
    }
  }
  .text {
    color: $white;
    @include pS;
    padding-top: 20px;
    ::v-deep a {
      color: $white;
      text-decoration: underline;
      &:visited {
        color: $white;
      }
    }

    .mobile & {
      padding: 10px 16px 60px;
      border-bottom: 1px solid $white-50;
    }
    .tablet & {
      padding: 5px 105px 50px 20px;
      border-bottom: 1px solid $white-50;
    }
  }
  .title {
    font-family: "Piazzolla";
    font-size: 30px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: $white;
    .mobile & {
      padding: 10px 16px 10px;
    }
    .tablet & {
      padding: 50px 105px 10px 20px;
    }
  }
}
</style>